<div class="  ">
  <h2 class="sectionTitle">Main Title</h2>

  <form>
      <div class="full-card">
        <div class="card-header">
          <label class="rating-label no-rate high-rate low-rate">High</label>
          <div class="form-container">
            <div class="form-group">
              <div class="custom-checkbox">
                <input type="checkbox" id="supplier1"  name="supplier1"  value="1" />
                <label for="supplier1">Number: <b>1</b></label>
              </div>
            </div>
            <div class="form-group">
              <div class="custom-checkbox">
                <label>Supplier Name:</label>
                <b>Egyptair Company</b>
              </div>
          </div>
        </div>
        </div>
        <div class="collapse" id="Etender1">
          <div class="card-body">
            <div class="form-container">
              <div class="form-group">
                <label>Responde</label>
                <div class="form-custom-inputs">
                  <div class="custom-Radio">
                    <input type="radio" id="radio1"  name="radioResponde"  value="1" />
                    <label for="radio1">decisions</label>
                  </div>
                  <div class="custom-Radio">
                    <input type="radio" id="radio2"  name="radioResponde"  value="2" />
                    <label for="radio2">decisions</label>
                  </div>
                </div>
            </div>
            <div class="form-group">
              <label>Responde 2</label>
              <div class="form-custom-inputs">
                <div class="custom-Radio">
                  <input type="radio" id="radio3"  name="radioResponde1"  value="4" />
                  <label for="radio3">decisions</label>
                </div>
                <div class="custom-Radio">
                  <input type="radio" id="radio4"  name="radioResponde1"  value="5" />
                  <label for="radio4">decisions</label>
                </div>
              </div>
          </div>
          <div class="form-group">
            <label>Responde</label>
            <div class="form-custom-inputs">
              <div class="custom-Radio">
                <input type="radio" id="radio5"  name="radioResponde2"  value="6" />
                <label for="radio5">decisions</label>
              </div>
              <div class="custom-Radio">
                <input type="radio" id="radio6"  name="radioResponde2"  value="7" />
                <label for="radio6">decisions</label>
              </div>
            </div>
            </div>
            <div class="form-group">
              <label>Responde</label>
              <textarea class="form-control"></textarea>
              </div>
              <div class="form-group">
                <label>Responde</label>
                <textarea class="form-control"></textarea>
                </div>
                </div>
          </div>
        </div>
        <div class="btn-holder full-width">
          <button type="button" class="btn SCAcustomBtn"  type="button" data-toggle="collapse" data-target="#Etender1" aria-expanded="false" aria-controls="Etender1">Evaluation</button>
        </div>
      </div>
    </form>
  

  <form>
    <div>
      <tabset #tabsID>
        <tab heading="Tab Heading">
          <div class="form-container">
            <div class="form-group">
              <label for="username">Label</label>
              <span class="red"> *</span>
              <input type="text" Name="username" class="form-control" />
              <div class="red">
                <span>This is invalid input</span>
              </div>
            </div>
            <div class="form-group">
              <label for="username">Label</label>
              <span class="red"> *</span>
              <input type="text" Name="username" class="form-control" />
              <div class="red">
                <span>This is invalid input</span>
              </div>
            </div>
            <div class="form-group">
              <label for="username">Label</label>
              <span class="red"> *</span>
              <input type="text" Name="username" class="form-control" />
              <div class="red">
                <span>This is invalid input</span>
              </div>
            </div>
            <div class="form-group">
              <label for="username">Label</label>
              <span class="red"> *</span>
              <input type="text" Name="username" class="form-control" />
              <div class="red">
                <span>This is invalid input</span>
              </div>
            </div>
          </div>
          <p class="btns-holder text-right">
            <button type="button" class="btn SCAcustomBtn" (click)="selectTab(1)">Next</button>
          </p>
        </tab>
        <tab heading="Tab Heading">
          <div class="form-container">
            <div class="form-section">
              <h4 class="section-title">Section Title</h4>
              <div class="form-group">
                <label for="username">Label</label>
                <span class="red"> *</span>
                <input type="text" Name="username" class="form-control" />
                <div class="red">
                  <span>This is invalid input</span>
                </div>
              </div>
              <div class="form-group">
                <label for="username">Label</label>
                <span class="red"> *</span>
                <input type="text" Name="username" class="form-control" />
                <div class="red">
                  <span>This is invalid input</span>
                </div>
              </div>
              <div class="form-group">
                <label for="username">Label</label>
                <span class="red"> *</span>
                <input type="text" Name="username" class="form-control" />
                <div class="red">
                  <span>This is invalid input</span>
                </div>
              </div>
              <div class="form-group">
                <label for="username">Label</label>
                <span class="red"> *</span>
                <input type="text" Name="username" class="form-control" />
                <div class="red">
                  <span>This is invalid input</span>
                </div>
              </div>
            </div>
            <div class="form-section">
              <h4 class="section-title">Section Title</h4>
              <div class="form-group">
                <label for="username">Label</label>
                <span class="red"> *</span>
                <input type="text" Name="username" class="form-control" />
                <div class="red">
                  <span>This is invalid input</span>
                </div>
              </div>
              <div class="form-group">
                <label for="username">Label</label>
                <span class="red"> *</span>
                <input type="text" Name="username" class="form-control" />
                <div class="red">
                  <span>This is invalid input</span>
                </div>
              </div>
              <div class="form-group">
                <label for="username">Label</label>
                <span class="red"> *</span>
                <input type="text" Name="username" class="form-control" />
                <div class="red">
                  <span>This is invalid input</span>
                </div>
              </div>
              <div class="form-group">
                <label for="username">Label</label>
                <span class="red"> *</span>
                <input type="text" Name="username" class="form-control" />
                <div class="red">
                  <span>This is invalid input</span>
                </div>
              </div>
            </div>
          </div>
          <p class="btns-holder text-right">
            <button type="button" class="btn SCAcustomBtn" (click)="selectTab(0)">Previous</button>
          </p>

        </tab>
      </tabset>
    </div>

    <div class="form-group">
      <button class="btn SCAcustomBtn">Submit</button>
      <a href="#" class="btn SCAcustomBtn">Cancel</a>
    </div>
  </form>

  <h2 class="sectionTitle">Table</h2>

  <div class="table-responsive">
    <table class="table table-bordered table-striped table-services">
      <thead>
        <tr>
          <th>Title</th>
          <th>Description</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            This is title
          </td>
          <td>Applies the hover color to a particular row or cell</td>
        </tr>
        <tr>
          <td>
            This is title
          </td>
          <td>Applies the hover color to a particular row or cell</td>
        </tr>
        <tr>
          <td>
            This is title
          </td>
          <td>Applies the hover color to a particular row or cell</td>
        </tr>
        <tr>
          <td>
            This is title
          </td>
          <td>Applies the hover color to a particular row or cell</td>
        </tr>
        <tr>
          <td>
            This is title
          </td>
          <td>Applies the hover color to a particular row or cell</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>